import React from "react";
import { PeekBox } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import ToggleSwitch from "@components/common/form/toggle-switch";
const ShareLinkToggleSwitch = (props) => {
    const intl = useIntl();
    return (React.createElement(PeekBox, { width: 160 },
        React.createElement(ToggleSwitch, Object.assign({ onLabel: intl.formatMessage(messages.spaceShareLinkFormToggleSwitchOn), offLabel: intl.formatMessage(messages.spaceShareLinkFormToggleSwitchOff) }, props))));
};
export default ShareLinkToggleSwitch;
